import { useEffect, useState, useRef } from 'react';

import ShoppingList from './ShoppingList';

import {
  getShoppingList,
  createShoppingList,
  getShoppingItems,
  addShoppingItem,
  toggleShoppingItem,
  deleteShoppingItem,
  updateShoppingItem,
  renameStore,
  deleteStore
} from './shoppingService';

export default function ShoppingPage({ currentUser }) {

  const [shoppingList, setShoppingList] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const [newItem, setNewItem] = useState('');
  const [newStore, setNewStore] = useState('');
  const [newQuantity, setNewQuantity] = useState('');
  const [saving, setSaving] = useState(false);

  const itemInputRef = useRef(null);

  const [editingItemId, setEditingItemId] = useState(null);

  console.log(items);

  const stores = [
    ...new Set(
      items
        .map(item => item.store)
        .filter(Boolean)
    )
  ].sort();

  useEffect(() => {
    loadShoppingData();
  }, [currentUser]);

  async function loadShoppingData() {

    if (!currentUser) return;

    setLoading(true);

    // GET EXISTING LIST
    let list = await getShoppingList(currentUser.id);

    // CREATE ONE IF NONE EXISTS
    if (!list) {
      list = await createShoppingList(currentUser.id);
    }

    setShoppingList(list);

    // LOAD ITEMS
    if (list) {
      const shoppingItems = await getShoppingItems(list.id);
      setItems(shoppingItems);
    }

    setLoading(false);
  }



async function handleAddItem() {

  if (!newItem.trim()) return;

  setSaving(true);

  // EDIT EXISTING ITEM
  if (editingItemId) {

    await updateShoppingItem(editingItemId, {
      name: newItem,
      quantity: newQuantity,
      store: newStore
    });

  } else {

    // CREATE NEW ITEM
    await addShoppingItem({
      shopping_list_id: shoppingList.id,
      name: newItem,
      store: newStore,
      quantity: newQuantity,
      completed: false
    });

  }

  const updatedItems = await getShoppingItems(shoppingList.id);

  setItems(updatedItems);

  clearForm();

  itemInputRef.current?.focus();

  setSaving(false);
}


  async function handleToggleItem(item)
  {
    await toggleShoppingItem(
      item.id,
      !item.completed
    );

    const updatedItems = await
    getShoppingItems(shoppingList.id);

    setItems(updatedItems);
  }

  async function handleDeleteItem(itemId) {

    await deleteShoppingItem(itemId);

    const updatedItems = await getShoppingItems(shoppingList.id);

    setItems(updatedItems);
  }

  async function handleEditStore(oldStore) {

  const newStoreName = prompt(
    'Rename store:',
    oldStore
  );

  if (
    !newStoreName ||
    newStoreName.trim() === '' ||
    newStoreName === oldStore
  ) {
    return;
  }

  await renameStore(
    oldStore,
    newStoreName.trim()
  );

  const updatedItems =
    await getShoppingItems(shoppingList.id);

  setItems(updatedItems);
}


async function handleDeleteStore(storeName) {

  const confirmed = window.confirm(
    `Delete store "${storeName}"?`
  );

  if (!confirmed) return;

  await deleteStore(
    shoppingList.id,
    storeName
  );

  const updatedItems =
    await getShoppingItems(shoppingList.id);

  setItems(updatedItems);
}


  function startEdit(item) {

    setEditingItemId(item.id);

    setNewItem(item.name);
    setNewQuantity(item.quantity || '');
    setNewStore(item.store || '');
  }

  function clearForm() {

    setNewItem('');
    setNewQuantity('');
    setNewStore('');

    setEditingItemId(null);
  }

    if (loading) {
    return (
      <div style={{ padding: '20px' }}>
        Loading shopping list...
      </div>
    );
  }

  {/*RETURN CODE*/}
  return (
    <div style={{ padding: '20px' }}>

      <h1>Shopping List</h1>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAddItem();
        }}
        style={{
          display: 'flex',
          gap: '10px',
          marginBottom: '20px',
          flexWrap: 'wrap'
        }}
      >
      <input
        type="text"
        placeholder="Item"
        value={newItem}
        onChange={(e) => setNewItem(e.target.value)}
        ref={itemInputRef}
        
      />

        <input
          type="text"
          placeholder="Quantity"
          value={newQuantity}
          onChange={(e) => setNewQuantity(e.target.value)}
        />

        <input
          list="store-options"
          placeholder="Store"
          value={newStore}
          onChange={(e) => setNewStore(e.target.value)}
        />

        <datalist id="store-options">
          {stores.map(store => (
            <option
              key={store}
              value={store}
            />
          ))}
        </datalist>

        <button
          type="submit"
          disabled={saving}
        >
          {editingItemId ? 'Save Changes' : 'Add'}
        </button>

        {editingItemId && (
          <button 
            type="button"
            onClick={clearForm}>
            Cancel
          </button>
        )}

      </form>


      <p>Total Items: {items.filter(item=> !item.completed).length}</p>

      <ShoppingList
        items={items}
        onToggle={handleToggleItem}
        onDelete={handleDeleteItem}
        onEdit={startEdit}
        onEditStore={handleEditStore}
        onDeleteStore={handleDeleteStore}
        editingItemId={editingItemId}
      />

    </div>
  );
}